/**
 * Image constants for frontend
 */

/**
 * SVG placeholder for products without images.
 * Displays a box emoji, scales to container size, transparent background.
 */
export const PRODUCT_PLACEHOLDER_SVG =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ctext font-size='40' text-anchor='middle' dominant-baseline='central' x='50' y='50'%3E📦%3C/text%3E%3C/svg%3E";
